import { Cloud, KeyRound, Mail, Plug, ShieldCheck } from 'lucide-react'
import { useSettings } from '../../api/hooks'
import { Badge, Card, PageHeader, Spinner } from '../../components/ui'

export function SettingsPage() {
  const s = useSettings()
  if (s.isLoading || !s.data) return <Spinner />
  const d = s.data
  const sso = d.auth_mode === 'oidc'
  const rows = [
    {
      icon: KeyRound, title: 'Inloggning',
      value: sso ? `SSO: ${d.auth_providers.join(' + ')}` : 'Lokalt utvecklingsläge – rollväxlare',
      prod: `Solvigo loggar in med Google (${d.google_hosted_domain ?? 'solvigo.ai'}) och blir superadministratörer. Söderberg & Partners loggar in med Microsoft Entra ID${d.microsoft_tenant_id ? ` (tenant ${d.microsoft_tenant_id.slice(0, 8)}…)` : ''} och blir administratörer, eller får rollen från app-roller i Entra${Object.keys(d.microsoft_role_map).length ? ` (${Object.entries(d.microsoft_role_map).map(([k, v]) => `${k} → ${v}`).join(', ')})` : ''}. Guide: docs/SSO-SETUP.md.`,
      ready: sso,
    },
    {
      icon: ShieldCheck, title: 'Sessioner och skydd',
      value: `Session ${d.session_ttl_hours} h, inaktiv ${d.session_idle_minutes} min`,
      prod: `Cookies: ${d.secure_cookies ? 'Secure + __Host-prefix (https)' : 'utan Secure – bara för http lokalt'}. Ursprungskontroll (CSRF) på alla skrivande anrop. Publika anmälningssidor begränsas till ${d.rate_limit_public_per_minute} anrop/minut per IP. ${d.trust_proxy_headers ? 'Klient-IP läses från lastbalanseraren.' : 'Klient-IP läses direkt (sätt TRUST_PROXY_HEADERS bakom lastbalanserare).'}`,
      ready: d.secure_cookies,
    },
    { icon: Plug, title: 'Dynamics 365', value: d.dynamics_mode === 'dynamics365' ? 'Ansluten' : 'Simulerad (fixturdata: 40 team)', prod: 'OAuth 2.0 client credentials mot Web API v9.2. Entiteter: Teams, SystemUsers, Accounts, Contacts. Nattlig synk 00.00 + manuell. Kräver mappningsworkshop med CRM-förvaltare.', ready: d.dynamics_mode === 'dynamics365' },
    { icon: Mail, title: 'E-postleverans', value: d.mail_mode === 'outbox' ? 'Utkorg (inget skickas)' : d.mail_mode, prod: 'SendGrid eller Microsoft Graph/Exchange Online. SPF/DKIM/DMARC på avsändardomänen, List-Unsubscribe, bounce-hantering via webhook.', ready: d.mail_mode !== 'outbox' },
    { icon: Cloud, title: 'Miljö', value: d.environment, prod: `Publik bas-URL för anmälningslänkar: ${d.public_base_url}. Produktion: kundens Azure eller Solvigo-drift (beslut vid kickoff).`, ready: d.environment === 'prod' },
  ]
  return (
    <>
      <PageHeader title="Inställningar" subtitle="Systemkonfiguration, säkerhet och status för externa integrationer." />
      <div className="grid gap-4 md:grid-cols-2">
        {rows.map((r) => (
          <Card key={r.title}>
            <div className="flex items-start gap-3">
              <span className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-navy-50 text-navy-700"><r.icon className="size-4" /></span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2"><h3 className="text-sm font-semibold">{r.title}</h3><Badge tone={r.ready ? 'success' : 'warning'} dot>{r.ready ? 'Produktion' : 'Pilot'}</Badge></div>
                <div className="mt-1 text-sm text-ink-900">{r.value}</div>
                <p className="mt-2 text-xs leading-relaxed text-ink-500">{r.prod}</p>
              </div>
            </div>
          </Card>
        ))}
      </div>
      <Card className="mt-4" title="Standardavsändare">
        <dl className="grid gap-3 text-sm sm:grid-cols-2">
          <div><dt className="text-xs text-ink-500">Namn</dt><dd>{d.mail_default_sender_name}</dd></div>
          <div><dt className="text-xs text-ink-500">Adress</dt><dd>{d.mail_default_sender_email}</dd></div>
        </dl>
        <p className="mt-3 text-xs text-ink-500">Används för bekräftelsemejl och som förval i nya inbjudningar. Sätts via miljövariabler; redigering i gränssnittet är planerad.</p>
      </Card>
    </>
  )
}
